import { amplitude } from 'wisestep-api';
import { IUserDTO } from 'wisestep-base';

import { JobsCrm } from '../components/helper/JobsCrmHelper';

export enum SocialSearchAmplitudeEvent {
  GOOGLE_DIRECT = 'google_direct',
  GOOGLE_LINKEDIN = 'google_linkedin',
  LINKEDIN = 'linkedin',
  INDEED = 'indeed',
  TWITTER = 'twitter',
}
export enum SocialSearchShare {
  FACEBOOK = 'facebook',
  WHATSAPP = 'whatsapp',
  LINKEDIN = 'linkedin',
  EMAIL = 'email',
  TWITTER = 'twitter',
}

export const amplitudeJobCrmUrl = () => {
  const parts = window.location.pathname.split('/');
  if (parts.indexOf('jobs-crm') > -1) {
    if (parts[parts.length - 1] === 'smartSource') return 'Ai_Suggestions';
    else if (parts[parts.length - 1] === 'candidate-similar-jobs') return 'Similar_Jobs';
    else {
      switch (parts[parts.length - 2]) {
        case '0':
          return 'Mappings';
        case '1':
          return 'Submission';
        case '2':
          return 'Application';
        case '3':
          return 'Uploaded';
      }
    }
  } else undefined;
};

export const amplitudeEventRefresh = {
  [JobsCrm.SMART_SOURCE]: (loggedInUser: IUserDTO) =>
    amplitude('Smart_Source_refresh', {
      userId: loggedInUser?.email,
      clickedOn: 'Refresh',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  [JobsCrm.PIPELINE]: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Pipeline_refresh', {
      userId: loggedInUser?.email,
      clickedOn: 'Refresh',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventAdvanceFilter = {
  [JobsCrm.SMART_SOURCE]: (loggedInUser: IUserDTO) =>
    amplitude('Smart_Source_advance_Filters', {
      userId: loggedInUser?.email,
      clickedOn: 'Advance Filter',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  [JobsCrm.PIPELINE]: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Pipeline_advance_Filters', {
      userId: loggedInUser?.email,
      clickedOn: 'Advance Filter',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};

export const amplitudeEventSocialSearch = {
  [JobsCrm.SMART_SOURCE]: {
    [SocialSearchAmplitudeEvent.GOOGLE_DIRECT]: (loggedInUser: IUserDTO) =>
      amplitude('Smart_Source_Social_search_Google_Direct', {
        userId: loggedInUser?.email,
        clickedOn: 'Social search Google Direct',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchAmplitudeEvent.GOOGLE_LINKEDIN]: (loggedInUser: IUserDTO) =>
      amplitude('Smart_Source_Social_search_Google_LinkedIn', {
        userId: loggedInUser?.email,
        clickedOn: 'Social search Google LinkedIn',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchAmplitudeEvent.LINKEDIN]: (loggedInUser: IUserDTO) =>
      amplitude('Smart_Source_Social_search_LinkedIn', {
        userId: loggedInUser?.email,
        clickedOn: 'Social search LinkedIn',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchAmplitudeEvent.INDEED]: (loggedInUser: IUserDTO) =>
      amplitude('Smart_Source_Social_search_Indeed', {
        userId: loggedInUser?.email,
        clickedOn: 'Social search Indeed',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchAmplitudeEvent.TWITTER]: (loggedInUser: IUserDTO) =>
      amplitude('Smart_Source_Social_search_Twitter', {
        userId: loggedInUser?.email,
        clickedOn: 'Social search Twitter',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
  },
  [JobsCrm.PIPELINE]: {
    [SocialSearchAmplitudeEvent.GOOGLE_DIRECT]: (loggedInUser: IUserDTO) =>
      amplitude('JobCRM_Pipeline_Social_search_Google_Direct', {
        userId: loggedInUser?.email,
        clickedOn: 'Social search Google Direct',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchAmplitudeEvent.GOOGLE_LINKEDIN]: (loggedInUser: IUserDTO) =>
      amplitude('JobCRM_Pipeline_Social_search_Google_LinkedIn', {
        userId: loggedInUser?.email,
        clickedOn: 'Social search Google LinkedIn',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchAmplitudeEvent.LINKEDIN]: (loggedInUser: IUserDTO) =>
      amplitude('JobCRM_Pipeline_Social_search_LinkedIn', {
        userId: loggedInUser?.email,
        clickedOn: 'Social search LinkedIn',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchAmplitudeEvent.INDEED]: (loggedInUser: IUserDTO) =>
      amplitude('JobCRM_Pipeline_Social_search_Indeed', {
        userId: loggedInUser?.email,
        clickedOn: 'Social search Indeed',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchAmplitudeEvent.TWITTER]: (loggedInUser: IUserDTO) =>
      amplitude('JobCRM_Pipeline_Social_search_Twitter', {
        userId: loggedInUser?.email,
        clickedOn: 'Social search Twitter',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
  },
};
export const amplitudeEventShare = {
  [JobsCrm.SMART_SOURCE]: {
    [SocialSearchShare.FACEBOOK]: (loggedInUser: IUserDTO) =>
      amplitude('Smart_Source_Share_facebook', {
        userId: loggedInUser?.email,
        clickedOn: 'Share_facebook',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchShare.WHATSAPP]: (loggedInUser: IUserDTO) =>
      amplitude('Smart_Source_Share_whatsapp', {
        userId: loggedInUser?.email,
        clickedOn: 'Share whatsapp',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchShare.LINKEDIN]: (loggedInUser: IUserDTO) =>
      amplitude('Smart_Source_Share_LinkedIn', {
        userId: loggedInUser?.email,
        clickedOn: 'Share LinkedIn',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchShare.TWITTER]: (loggedInUser: IUserDTO) =>
      amplitude('Smart_Source_Share_twitter', {
        userId: loggedInUser?.email,
        clickedOn: 'Share twitter',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchShare.EMAIL]: (loggedInUser: IUserDTO) =>
      amplitude('Smart_Source_Share_Email', {
        userId: loggedInUser?.email,
        clickedOn: 'Share Email',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
  },
  [JobsCrm.PIPELINE]: {
    [SocialSearchShare.FACEBOOK]: (loggedInUser: IUserDTO) =>
      amplitude('JobCRM_Pipeline_Share_facebook', {
        userId: loggedInUser?.email,
        clickedOn: 'Share_facebook',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchShare.WHATSAPP]: (loggedInUser: IUserDTO) =>
      amplitude('JobCRM_Pipeline_Share_whatsapp', {
        userId: loggedInUser?.email,
        clickedOn: 'Share whatsapp',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchShare.LINKEDIN]: (loggedInUser: IUserDTO) =>
      amplitude('JobCRM_Pipeline_Share_LinkedIn', {
        userId: loggedInUser?.email,
        clickedOn: 'Share LinkedIn',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchShare.LINKEDIN]: (loggedInUser: IUserDTO) =>
      amplitude('JobCRM_Pipeline_Share_twitter', {
        userId: loggedInUser?.email,
        clickedOn: 'Share twitter',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
    [SocialSearchShare.EMAIL]: (loggedInUser: IUserDTO) =>
      amplitude('JobCRM_Pipeline_Share_Email', {
        userId: loggedInUser?.email,
        clickedOn: 'Share Email',
        pageName: 'JobCrm',
        pageUrl: window.location.href,
      }),
  },
};
export const amplitudeEventJobCrmPipelineMappings = {
  ['View CV']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_View_CV', {
      userId: loggedInUser?.email,
      clickedOn: 'View CV',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Map as Lead']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_Map_as_Lead', {
      userId: loggedInUser?.email,
      clickedOn: 'Map as Lead',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Share']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_share', {
      userId: loggedInUser?.email,
      clickedOn: 'Share',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Create Reminder']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_Create_reminder', {
      userId: loggedInUser?.email,
      clickedOn: 'Create Reminder',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Send Email']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_Send Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Send Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Copy']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_Copy Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Copy Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Send SMS']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_Send SMS', {
      userId: loggedInUser?.email,
      clickedOn: 'Send SMS',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['submit']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_SUBMIT', {
      userId: loggedInUser?.email,
      clickedOn: 'Submit',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineSubmissions = {
  ['View CV']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_View_CV', {
      userId: loggedInUser?.email,
      clickedOn: 'View CV',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Update Status']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_Update_Status', {
      userId: loggedInUser?.email,
      clickedOn: 'Update Status',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Send Email']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_Send Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Send Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Copy']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_Copy Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Copy Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Send SMS']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_Send SMS', {
      userId: loggedInUser?.email,
      clickedOn: 'Send SMS',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineApplication = {
  ['View CV']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_View_CV', {
      userId: loggedInUser?.email,
      clickedOn: 'View CV',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Map as Lead']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_Map_as_Lead', {
      userId: loggedInUser?.email,
      clickedOn: 'Map as Lead',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Share']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_share', {
      userId: loggedInUser?.email,
      clickedOn: 'Share',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Send Email']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_Send Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Send Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Copy']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_Copy Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Copy Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Send SMS']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_Send SMS', {
      userId: loggedInUser?.email,
      clickedOn: 'Send SMS',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Mark Primary']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_Mark as Primary', {
      userId: loggedInUser?.email,
      clickedOn: 'Primary',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineUploaded = {
  ['View CV']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_View_CV', {
      userId: loggedInUser?.email,
      clickedOn: 'View CV',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Map as Lead']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_Map_as_Lead', {
      userId: loggedInUser?.email,
      clickedOn: 'Map as Lead',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Share']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_share', {
      userId: loggedInUser?.email,
      clickedOn: 'Share',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Send Email']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_Send Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Send Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Copy']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_Copy Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Copy Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Send SMS']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_Send SMS', {
      userId: loggedInUser?.email,
      clickedOn: 'Send SMS',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Mark Primary']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_Mark as Primary', {
      userId: loggedInUser?.email,
      clickedOn: 'Send SMS',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceAiSuggestionsSelectUnselect = {
  ['Select candidate']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Select', {
      userId: loggedInUser?.email,
      clickedOn: 'Select candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['UnSelect candidate']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_UnSelect', {
      userId: loggedInUser?.email,
      clickedOn: 'UnSelect candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceSimilarJobsSelectUnselect = {
  ['Select candidate']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Select', {
      userId: loggedInUser?.email,
      clickedOn: 'Select candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['UnSelect candidate']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_UnSelect', {
      userId: loggedInUser?.email,
      clickedOn: 'UnSelect candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineMappingsSelectUnselect = {
  ['Select candidate']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_Select', {
      userId: loggedInUser?.email,
      clickedOn: 'Select candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['UnSelect candidate']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_UnSelect', {
      userId: loggedInUser?.email,
      clickedOn: 'UnSelect candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineSubmissionsSelectUnselect = {
  ['Select candidate']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_Select', {
      userId: loggedInUser?.email,
      clickedOn: 'Select candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['UnSelect candidate']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_UnSelect', {
      userId: loggedInUser?.email,
      clickedOn: 'UnSelect candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineApplicationsSelectUnselect = {
  ['Select candidate']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_Select', {
      userId: loggedInUser?.email,
      clickedOn: 'Select candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['UnSelect candidate']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_UnSelect', {
      userId: loggedInUser?.email,
      clickedOn: 'UnSelect candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineUploadedSelectUnselect = {
  ['Select candidate']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_Select', {
      userId: loggedInUser?.email,
      clickedOn: 'Select candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['UnSelect candidate']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_UnSelect', {
      userId: loggedInUser?.email,
      clickedOn: 'UnSelect candidate',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmRemindersCard = {
  ['Edit']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_edit_Reminders', {
      userId: loggedInUser?.email,
      clickedOn: 'Edit Reminder',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Snooze']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_snooze_Reminders', {
      userId: loggedInUser?.email,
      clickedOn: 'Snooze',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Complete']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Complete_Reminders', {
      userId: loggedInUser?.email,
      clickedOn: 'Complete',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPublishJob = {
  [JobsCrm.SMART_SOURCE]: (loggedInUser: IUserDTO) =>
    amplitude('Smart_Source_Publish_Job', {
      userId: loggedInUser?.email,
      clickedOn: 'Publish Job',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  [JobsCrm.PIPELINE]: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Pipeline_Publish_Job', {
      userId: loggedInUser?.email,
      clickedOn: 'Publish Job',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmViewDetailsJD = {
  [JobsCrm.SMART_SOURCE]: (loggedInUser: IUserDTO) =>
    amplitude('Smart_Source_View_Details_JD', {
      userId: loggedInUser?.email,
      clickedOn: 'View Deatils JD',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  [JobsCrm.PIPELINE]: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Pipeline_View_Details_JD', {
      userId: loggedInUser?.email,
      clickedOn: 'View Deatils JD',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmViewAssignees = {
  [JobsCrm.SMART_SOURCE]: (loggedInUser: IUserDTO) =>
    amplitude('Smart_Source_View_assignees', {
      userId: loggedInUser?.email,
      clickedOn: 'View Assignees',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  [JobsCrm.PIPELINE]: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Pipeline_View_assignees', {
      userId: loggedInUser?.email,
      clickedOn: 'View Assignees',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmViewBroadcastJobToVendors = {
  [JobsCrm.SMART_SOURCE]: (loggedInUser: IUserDTO) =>
    amplitude('Smart_Source_Broadcast_Job_Vendors', {
      userId: loggedInUser?.email,
      clickedOn: 'Broadcast Job to Vendors',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  [JobsCrm.PIPELINE]: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Pipeline_Broadcast_Job_Vendors', {
      userId: loggedInUser?.email,
      clickedOn: 'Broadcast Job to Vendors',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmViewJobPosting = {
  [JobsCrm.SMART_SOURCE]: (loggedInUser: IUserDTO) =>
    amplitude('Smart_Source_View Job Posting', {
      userId: loggedInUser?.email,
      clickedOn: 'View Job Posting',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  [JobsCrm.PIPELINE]: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Pipeline_View Job Posting', {
      userId: loggedInUser?.email,
      clickedOn: 'View Job Posting',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceCalender = {
  ['AI_Suggestions']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Calender', {
      userId: loggedInUser?.email,
      clickedOn: 'Calender',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Similar_Jobs']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Calender', {
      userId: loggedInUser?.email,
      clickedOn: 'Calender',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceTask = {
  ['AI_Suggestions']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Create_reminder', {
      userId: loggedInUser?.email,
      clickedOn: 'Task',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Similar_Jobs']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Create_reminder', {
      userId: loggedInUser?.email,
      clickedOn: 'Task',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceShare = {
  ['AI_Suggestions']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_share', {
      userId: loggedInUser?.email,
      clickedOn: 'Share',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Similar_Jobs']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_share', {
      userId: loggedInUser?.email,
      clickedOn: 'Share',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceViewCV = {
  ['AI_Suggestions']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_View_CV', {
      userId: loggedInUser?.email,
      clickedOn: 'View CV',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Similar_Jobs']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_View_CV', {
      userId: loggedInUser?.email,
      clickedOn: 'View CV',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceMapAsLead = {
  ['AI_Suggestions']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Map_as_Lead', {
      userId: loggedInUser?.email,
      clickedOn: 'Map As Lead',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Similar_Jobs']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Map_as_Lead', {
      userId: loggedInUser?.email,
      clickedOn: 'Map As Lead',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceActionFilter = {
  ['action_filter']: (loggedInUser: IUserDTO) =>
    amplitude('Smart_Source_action_CTA', {
      userId: loggedInUser?.email,
      clickedOn: 'Action Filter',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};

export const amplitudeEventJobCrmPipelineActionFilter = {
  ['action_filter']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Pipeline_action_CTA', {
      userId: loggedInUser?.email,
      clickedOn: 'Action Filter',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceCard = {
  ['AI_Send_Email']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Send Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Send Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Similar_Send_Email']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Send Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Send Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['AI_Copy_Email']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Copy Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Copy Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Similar_Copy_Email']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Copy Email', {
      userId: loggedInUser?.email,
      clickedOn: 'Copy Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['AI_Send_SMS']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Send SMS', {
      userId: loggedInUser?.email,
      clickedOn: 'Send SMS',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Similar_Send_SMS']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Send SMS', {
      userId: loggedInUser?.email,
      clickedOn: 'Send SMS',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['AI_Edit']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Phone_Edit', {
      userId: loggedInUser?.email,
      clickedOn: 'Edit',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Similar_Edit']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Phone_Edit', {
      userId: loggedInUser?.email,
      clickedOn: 'Edit',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['AI_Call']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Phone_call', {
      userId: loggedInUser?.email,
      clickedOn: 'Call',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Similar_Call']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Phone_call', {
      userId: loggedInUser?.email,
      clickedOn: 'Call',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmTabs = {
  ['mappings']: (loggedInUser: IUserDTO) =>
    amplitude('Jobcrm_Mapping', {
      userId: loggedInUser?.email,
      clickedOn: 'mappings',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['submissions']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission', {
      userId: loggedInUser?.email,
      clickedOn: 'submissions',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Applications']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application', {
      userId: loggedInUser?.email,
      clickedOn: 'applications',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['uploaded']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded', {
      userId: loggedInUser?.email,
      clickedOn: 'uploaded',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceAiEmailSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Send EmailSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),

  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Send EmailFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceSimilarJobsEmailSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Send EmailSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Send EmailFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineMappingEmailSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_Send EmailSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_Send EmailFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineSubmissionsEmailSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_Send EmailSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_Send EmailFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineUploadedEmailSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_Send EmailSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_Send EmailFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineApplicationsEmailSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_Send EmailSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_Send EmailFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Email',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineApplicationsPhoneSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_Send SMSSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_candidate_Send SMSFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineUploadedPhoneSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_Send SMSSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_candidate_Send SMSFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineSubmissionsPhoneSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_Send SMSSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Submission_candidate_Send SMSFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineMappingsPhoneSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_Send SMSSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_candidate_Send SMSFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceAiPhoneSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Send SMSSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('AI_candidate_Send SMSFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceSimilarJobsPhoneSuccessFail = {
  ['Success']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Send SMSSuccess', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['Failed']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_candidate_Send SMSFail', {
      userId: loggedInUser?.email,
      clickedOn: 'Phone',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceAiMapAsLeadSave = {
  ['Save']: (loggedInUser: IUserDTO) =>
    amplitude('AI_Map_as_Lead_Save', {
      userId: loggedInUser?.email,
      clickedOn: 'Save',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmSmartSourceSimilarJobsMapAsLeadSave = {
  ['Save']: (loggedInUser: IUserDTO) =>
    amplitude('Candidate_Similar_Jobs_Map_as_Lead_Save', {
      userId: loggedInUser?.email,
      clickedOn: 'Save',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineMappingsMapAsLeadSave = {
  ['Save']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Mapping_Map_as_Lead_Save', {
      userId: loggedInUser?.email,
      clickedOn: 'Save',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineApplicationsMapAsLeadSave = {
  ['Save']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Application_Map_as_Lead_Save', {
      userId: loggedInUser?.email,
      clickedOn: 'Save',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
export const amplitudeEventJobCrmPipelineUploadedMapAsLeadSave = {
  ['Save']: (loggedInUser: IUserDTO) =>
    amplitude('JobCRM_Uploaded_Map_as_Lead_Save', {
      userId: loggedInUser?.email,
      clickedOn: 'Save',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};

export const amplitudeEventSimilarJobsMapAsLeadANdSubmitSave = {
  ['Map as Lead']: (loggedInUser: IUserDTO) =>
    amplitude('Similar_Jobs_Map_as_Lead_Save', {
      userId: loggedInUser?.email,
      clickedOn: 'Save',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
  ['submit']: (loggedInUser: IUserDTO) =>
    amplitude('Similar_Jobs_Submit_Save', {
      userId: loggedInUser?.email,
      clickedOn: 'Save',
      pageName: 'JobCrm',
      pageUrl: window.location.href,
    }),
};
